<dv-dialog-content>
  @if (formGroup) {
    <div>
      <dv-dynamic-form
        [elements]="elements | translateElements"
        [formGroup]="formGroup">
      </dv-dynamic-form>
    </div>
  }
  <dv-button footer-right (click)="cancel()">
    {{ 'General.Cancel' | translate }}
  </dv-button>
  <dv-button
    footer-right
    color="secondary"
    (click)="performSave()"
    [disabled]="!formGroup.valid || !formGroup.dirty">
    {{ 'General.Save' | translate }}
  </dv-button>
</dv-dialog-content>
